<nb-checkbox [checked]="value" [disabled]="true">
    <ng-content></ng-content>
    {{value ? 'Yes' : 'No'}}
</nb-checkbox>